import { useQuery } from '@tanstack/react-query'
import { featureQueries } from '../api/features'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useFeatures = () => {
  const { data: features, isLoading } = useQuery(featureQueries.getFeatures())

  return {
    enabledFeatures: {
      ticket: features?.global.includes('ticket'),
    },
    isLoading,
  }
}
